module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAgCAYAAAAffCjxAAAAAXNSR0IArs4c6QAAAR9JREFUSA2t1UEOgjAQBVAQ9670DCR6A1dyA1hwSBa4cotx4Q3kEpqYeACC8w2QARw6LTSptLU+ZkqLnrdQ8Vsny7ILtTdU4zRNX+249rpiE4Ecfd+/5nm+Y+OqJodiQsq6rvdVVRUU4VYlNJO61NDHjxERsAY9adPsQXOwEeSK/YVcMBEaYtR/UI2kNZuEbDAjpMVUEDBsUuwvbA3qjtJUQybMCprCrCEJc4IYdqM1C+k4vfmhxfdOhTDPCcLhbp4goinp7qF1atIbwgqSEKyHGppC1JAJUUEaxAgBoUkF1YPp1SuukQ0iRmSLAFrjg5chEgRBlCSJ8Q+zl5qAPPmNpHYHzUGA87N2pv7v6TTpqCJpI+TQhwbvLkiLLXL9ArVKEycS3VoFAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/arrow_icon.png
// module id = 194
// module chunks = 1